import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import {ToastNotification} from './styles';

@inject('store')
@observer
class ToastNotificationComponent extends Component {
  render() {
    const {
      store: {
        toastNotifications: {removeNotification}
      },
      notification: {type, id, message}
    } = this.props;

    return (
      <ToastNotification type={type} onClick={() => removeNotification(id)} key={id}>
        {message}
      </ToastNotification>
    );
  }
}

export default ToastNotificationComponent;
